const schema = [
        ['month'],
        ['availability'],
        ['user'],
];

export default schema;
